import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const mobileAppManagementRouter = [
  {
    path: 'mobile-app-management',
    component: () =>
      import('@/features/settingsManagement/mobileAppManagement/MobileAppManagementLayout.vue'),
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.MobileAppView,
    },
    children: [
      {
        path: '',
        component: () =>
          import('@/features/settingsManagement/mobileAppManagement/MobileAppManagementMain.vue'),
        meta: { permissionAction: PermissionActions.MobileAppView },
      },
      {
        path: 'chat-reports',
        component: () =>
          import('@/features/settingsManagement/mobileAppManagement/chatReports/ChatReports.vue'),
        meta: { permissionAction: PermissionActions.MobileAppChatReportsView },
      },
      {
        path: 'chat-reports/:chatReportId',
        component: () =>
          import('@/features/settingsManagement/mobileAppManagement/chatReports/ChatReportDetail.vue'),
        meta: { permissionAction: PermissionActions.MobileAppChatReportsView },
      },
      {
        path: 'reports',
        component: () =>
          import('@/features/settingsManagement/mobileAppManagement/reports/ChatListOfUsersReports.vue'),
        meta: { permissionAction: PermissionActions.MobileAppUsersReportView },
      },
    ],
  },
]
